import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Header from './header';
import Nav from './nav';
import { useQuery } from '@tanstack/react-query';
import { httpGetMe } from 'data/user';
import useUserStore from 'clientStore/useUserStore';
import AppErrorBoundary from 'components/AppErrorBoundary';
import PinnedBottomNav from './PinnedBottomNav';
import { extractMeUser } from 'utils/companyHelpers';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 64;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 16,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 16,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  }
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(() => {
    const saved = localStorage.getItem('sidebarOpen');
    if (saved !== null) {
      return saved === 'true';
    }
    return window.innerWidth >= 1200;
  });

  useEffect(() => {
    localStorage.setItem('sidebarOpen', String(open));
  }, [open]);

  const { setUser } = useUserStore();

  const queryMeState = useQuery({
    queryKey: ['me'],
    queryFn: httpGetMe,
    select: (response) => response.data
  });

  useEffect(() => {
    if (queryMeState.isSuccess) {
      const meUser = extractMeUser(queryMeState?.data);
      setUser(meUser ? { data: meUser } : queryMeState?.data);
    }
  }, [queryMeState.isSuccess, queryMeState.data, setUser]);

  return (
    <StyledRoot>
      <Header openNav={open} onOpenNav={() => setOpen(true)} />
      <Nav openNav={open} toggleNav={() => setOpen(!open)} onCloseNav={() => setOpen(false)} />
      <Main>
        <AppErrorBoundary>
          <Outlet />
        </AppErrorBoundary>
      </Main>
      <PinnedBottomNav />
    </StyledRoot>
  );
}
